import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const top = css`
  margin: ${spacing.md}px 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      transform: translateY(${pxToRem(spacing.xl)});
      margin: 0;
    `,
  )};
`;

export const bottom = css`
  transform: translateY(-${pxToRem(spacing.lg)});

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      transform: translateY(-${pxToRem(spacing.xl)});
    `,
  )}
`;

export const imageContainer = css`
  display: flex;
  position: relative;
  width: 100%;
  box-sizing: border-box;
`;

export const image = css`
  width: 100%;
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(8)} 0 rgba(0, 0, 0, 0.2);
  border-radius: ${pxToRem(10)};
  overflow: hidden;
  height: auto;
`;

export const ar11 = css`
  aspect-ratio: 1 / 1;
`;

export const ar43 = css`
  aspect-ratio: 4 / 3;
`;

export const ar169 = css`
  aspect-ratio: 16 / 9;
`;

export const arAuto = css`
  aspect-ratio: auto;
`;
